import { useState, useCallback } from "react";
import axios from "axios";
import config from "../config";
import { useAuth } from "../store/auth-context";

const API_BASE_URL = config.BACKEND_URL || '';

const useApiHook = () => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [error, setError] = useState(null);
    const [headers, setHeaders] = useState({});
    const [controller, setController] = useState(null);

    const { token } = useAuth();

    const makeRequest = useCallback(async (url, method = 'get', requestData = {}, options = {}) => {
        try {
            options = { responseType: 'json', token: null, ...options };
            setError(null);
            setUploadProgress(0);
            setLoading(true);

            const newController = new AbortController();
            setController(newController);

            let isFile = false;
            let bodyData = requestData;

            Object.keys(requestData).forEach((key) => {
                if (key === 'audioFile')
                    isFile = true;
            });

            if (isFile) {
                const formData = new FormData();
                Object.keys(requestData).forEach((key) => {
                    formData.append(key, requestData[key]);
                });
                bodyData = formData;
            }

            const axiosConfig = {
                headers: {
                    "Content-Type": isFile ? "multipart/form-data" : "application/json",
                    "Authorization": `Bearer ${options.token || token}`,
                },
                signal: newController.signal,
                responseType: options.responseType,
                url: API_BASE_URL + url,
                method,
                onUploadProgress: ({ progress }) => {
                    setUploadProgress(+(progress * 100))
                }
            };

            const normalizedMethod = method.toLowerCase();

            if (normalizedMethod === 'get' || normalizedMethod === 'head') {
                axiosConfig.params = requestData;
            } else {
                axiosConfig.data = bodyData;
            }

            const resp = await axios(axiosConfig);
            setResponse(resp.data);
            setHeaders(resp.headers.toJSON());
            setError(null);
            setLoading(false);
            return resp.data;
        } catch (error) {
            setLoading(false);
            if (axios.isCancel(error)) {
                console.log("Upload cancelled");
                setError("Upload annullato dall'utente")
            } else {
                setError(error.response ? error.response.data : error);
                if (error.response && error.response.data) {
                    return error.response.data;
                }
            }
            return null;
        }
    }, [token]);

    const cancelRequest = useCallback(() => {
        if (controller) {
            controller.abort();
            setController(null);
        }
    }, [controller]);

    return { makeRequest, cancelRequest, response, headers, uploadProgress, loading, error };
}

export default useApiHook;
